import React from 'react';
import { useState } from 'react';
import { BookOpen, Settings, Menu, X, CheckCircle2 } from 'lucide-react';

const navigation = [
  { name: 'Student Dashboard', href: '/students/dashboard', icon: BookOpen },
  { name: 'Completed Assessments', href: '/students/completed-assessments', icon: CheckCircle2 },
  { name: 'Settings', href: '/students/settings', icon: Settings },
];

export function StudentSidebar() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleNavigation = (href) => {
    window.location.href = `#${href}`;
    setSidebarOpen(false);
  };

  return (
    <>
      {/* Mobile sidebar */}
      <div className={`fixed inset-0 z-50 sm:hidden ${sidebarOpen ? 'block' : 'hidden'}`}>
        <div className="fixed inset-0 bg-gray-600 bg-opacity-75" onClick={() => setSidebarOpen(false)} />
        <div className="fixed inset-y-0 left-0 flex w-72 flex-col bg-white shadow-xl">
          <div className="flex h-20 items-center justify-between px-6 border-b border-gray-200">
            <h1 className="text-xl font-bold text-gray-900">Learn Your Way</h1>
            <button
              type="button"
              className="rounded-md p-2 text-gray-400 hover:bg-gray-100 hover:text-gray-600 transition-colors"
              onClick={() => setSidebarOpen(false)}
            >
              <X className="h-6 w-6" />
            </button>
          </div>
          <nav className="flex-1 px-6 py-8">
            <ul className="space-y-3">
              {navigation.map((item) => {
                const Icon = item.icon;
                return (
                  <li key={item.name}>
                    <button
                      onClick={() => handleNavigation(item.href)}
                      className="group flex w-full items-center rounded-lg px-4 py-3 text-sm font-medium text-gray-700 hover:bg-action-blue/10 hover:text-action-blue-dark transition-colors"
                    >
                      <Icon className="mr-4 h-5 w-5 text-gray-500 group-hover:text-action-blue" />
                      {item.name}
                    </button>
                  </li>
                );
              })}
            </ul>
          </nav>
        </div>
      </div>

      {/* Desktop/Tablet sidebar */}
      <div className="hidden sm:fixed sm:inset-y-0 sm:flex sm:w-72 sm:flex-col">
        <div className="flex flex-grow flex-col overflow-y-auto border-r border-gray-200 bg-white shadow-sm">
          <div className="flex flex-shrink-0 items-center px-6 py-8 border-b border-gray-200">
            <h1 className="text-2xl font-bold text-gray-900">Learn Your Way</h1>
          </div>
          <nav className="flex flex-1 flex-col px-6 py-8">
            <div className="space-y-2">
              {navigation.map((item) => {
                const Icon = item.icon;
                return (
                  <button
                    key={item.name}
                    onClick={() => handleNavigation(item.href)}
                    className="group flex w-full items-center rounded-lg px-4 py-3 text-sm font-medium text-gray-700 hover:bg-action-blue/10 hover:text-action-blue-dark transition-colors"
                  >
                    <Icon className="mr-4 h-5 w-5 text-gray-500 group-hover:text-action-blue" />
                    {item.name}
                  </button>
                );
              })}
            </div>
          </nav>
        </div>
      </div>

      {/* Mobile menu button */}
      <div className="sm:hidden">
        <div className="flex h-16 items-center justify-between px-4 bg-white border-b border-gray-200">
          <button
            type="button"
            className="rounded-md p-2 text-gray-500 hover:bg-gray-100 hover:text-gray-600 transition-colors"
            onClick={() => setSidebarOpen(true)}
          >
            <Menu className="h-6 w-6" />
          </button>
          <h1 className="text-lg font-semibold text-gray-900">Learn Your Way</h1>
          <div className="w-10" />
        </div>
      </div>
    </>
  );
}
